module.exports = __webpack_public_path__ + "static/media/video_consent_audio_manipuri.70b2c7ad.mp3";